/** The app's default query retry: up to twice, except for failures a retry cannot fix. */
export function defaultQueryRetry(failureCount: number, error: unknown): boolean {
  const status =
    typeof error === 'object' && error !== null && 'status' in error ? error.status : undefined;
  // Permanent auth/not-found failures never succeed on retry.
  if (status === 401 || status === 403 || status === 404) {
    return false;
  }

  return failureCount < 2;
}
